import React from 'react';
import Input from '../elements/input';
var InputBox = function (props) {
    return (React.createElement(Input, { type: props.type, onKeyDown: props.handleKeyDown, onChange: props.handleChange, onFocus: props.handleFocus, name: props.name, ref: props.inputRef, pattern: '[0-9]*', min: '0', step: '1', style: { fontSize: '2.5rem', height: '100px' } }));
};
export default InputBox;
